import { IPlane } from "@base/math/Plane";
import { IRay2 } from "@base/math/Ray2";
import { IRay3 } from "@base/math/Ray3";
import { IVec2, Vec2 } from "@base/math/Vec2";
import { IVec3, Vec3 } from "@base/math/Vec3";

export class IntersectionUtil {
  static intersect(ray: IRay3, plane: IPlane, allowBehind?: boolean): IVec3 | undefined {
    const dot = Vec3.dot(plane.n, ray.direction);
    if (Math.abs(dot) < 0.000001)
      return undefined;// parallel

    const t = (plane.d - Vec3.dot(plane.n, ray.origin)) / dot;
    if (t < 0 && !allowBehind)
      return undefined;

    return Vec3.addScaled(ray.origin, ray.direction, t);
  }

  static intersectRay2(ray1: IRay2, ray2: IRay2): IVec2 | undefined {
    const div = ray2.direction.x * ray1.direction.y - ray1.direction.x * ray2.direction.y;
    if (Math.abs(div) <= Number.EPSILON)
      return undefined;

    const s = (ray2.direction.x * (ray2.origin.y - ray1.origin.y) - (ray2.origin.x - ray1.origin.x) * ray2.direction.y) / div;

    return Vec2.from(
      ray1.origin.x + ray1.direction.x * s,
      ray1.origin.y + ray1.direction.y * s
    )
  }
}